export default "__VITE_ASSET__b595be49__"